import {Divider, Text} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../../commons/hooks/currency'
import {useAppSelector} from '../../../../../hooks/runtime'
import {getEvent} from '../../../../../selectors/event'
import {getWholeTableReservationPrice, isPlaceReservableAsWhole} from '../../../../../selectors/seating/place'
import {WholeElementReservationProps} from './interfaces'
import {classes} from './whole-element-reservation.st.css'

export const WholeElementReservation = ({
  place,
  basketView,
  inDescription,
  showAccessibilityMode,
}: WholeElementReservationProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney, getTicketPriceText} = useCurrencyFormatter()

  const event = useAppSelector(getEvent)

  if (!isPlaceReservableAsWhole(place)) {
    return null
  }

  const getClassName = () => {
    const styledContainer = basketView || inDescription || showAccessibilityMode

    if (styledContainer) {
      return classes.container
    }

    return ''
  }

  return (
    <div className={getClassName()}>
      <Divider className={classes.divider} />
      <Text className={classes.tableReservation}>
        {t('seating_tableReservation', {
          price: getWholeTableReservationPrice({
            event,
            place,
            t,
            getFormattedMoney,
            getTicketPriceText,
          }),
        })}
      </Text>
    </div>
  )
}
